/**
 * View model for eco packaging service
 */
export interface IEcoPackagingModel {
  /** Flag for service is selected */
  checked: boolean;
  /** State of the service - enabled/disabled (indicates reason when disabled) */
  state: EcoPackagingState;
  /** The price */
  price: number;
}

export enum EcoPackagingState {
  ENABLED = 'ENABLED',
  DISABLED_DISCO = 'DISABLED_DISCO',
  DISABLED_GIFT = 'DISABLED_GIFT',
  DISABLED_FEATURE = 'DISABLED_FEATURE',
}
